<template>
    <div id="send-receipt">
        <div class="center-group">
            <img height="120px" src="@/assets/error_big.svg" width="120px" />
        </div>
        <div class="center-span">
            <div class="center-info">
                <label class="headline">Kvittens från E-hälsomyndigheten</label><br />
                Status: {{ messageStatusDisplay(response.messageStatus) }}<br />
                <template v-for="item in response.statusInformation">
                    <!-- eslint-disable-next-line -->
                    Statuskod: {{ item.statusCode }} <br />
                    <!-- eslint-disable-next-line -->
                    {{ item.description }} <br />
                </template>
            </div>
            <ButtonGroup>
                <Button type="button" @click="close()">Stäng</Button>
            </ButtonGroup>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import dialogEvents from "@/dialogEvents";
    import Button from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";

    export default {
        name: "SendReceipt",
        props: ["standalone"], //Remove when PrescriptionSet.vue is deprecated
        components: {
            ButtonGroup,
            Button,
        },
        data() {
            return {
                response: this.$attrs.response,
            };
        },
        computed: {
            ...mapGetters("patientData", ["personId", "name"]),
        },
        methods: {
            close() {
                dialogEvents.$emit("closePopup");
            },
            messageStatusDisplay(messageStatus) {
                let displayName = "";
                switch (messageStatus) {
                    case "0":
                        displayName = "Accepterat utan upptäckta fel";
                        break;
                    case "1":
                        displayName = "Accepterat med varningar";
                        break;
                    case "2":
                        displayName = "Förkastat, kan ej hanteras av mottagaren";
                        break;
                }
                return displayName;
            },
        },
    };
</script>
<style lang="scss" scoped>
    #send-receipt {
        position: relative;

        .center-group {
            width: 100%;
            text-align: center;
            margin-top: 16px;
        }

        .center-span {
            display: block;
            width: 722px;
            margin-top: 28px;
            margin-left: auto;
            margin-right: auto;
        }

        .headline {
            color: #277692;
            font-weight: bold;
        }

        .center-info {
            width: 100%;
            border-radius: 6px;
            background-color: #e4e8f0;
            padding: 27px;
            color: #354052;
            font-size: 16px;
            letter-spacing: 0;
            line-height: 23px;
            margin-bottom: 28px;
        }
    }
</style>
